import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ToolTip = ({
  children,
  placement = "top",
  content,
  delay = { show: 250, hide: 200 },
  className = "",
}) => {
  if (!content) return children;
  return (
    <OverlayTrigger
      key={placement}
      delay={delay}
      placement={placement}
      overlay={
        <Tooltip id={`tooltip-${placement}`} className={className}>
          {content}
        </Tooltip>
      }
    >
      <strong className="d-inline-block">{children}</strong>
    </OverlayTrigger>
  );
};

export default ToolTip;
